import { HStack, VStack } from "@gluestack-ui/themed";
import { ClientInfoSectionProps } from "./types";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import { GeneralInfo } from "../../infos/GeneralInfo";

export const ClientInfoSection = ({
  title,
  icon,
  name,
  fone,
  card
}: ClientInfoSectionProps) => {
  return (
    <VStack gap={16} py="$4">
      <HStack alignItems="center" gap={8}>
        <Icon name={icon} size={18} variant="solid" />
        <Text fontWeight={600}>{title}</Text>
      </HStack>

      <GeneralInfo name="Nome" value={name} />
      {fone && <GeneralInfo name="Telefone" value={fone} />}
      {card && <GeneralInfo name="Cartão" value={card} />}
    </VStack>
  );
};
